import { Typography, Show, Checkbox } from '@sanlam-glacier/app-common/components';
import { StatementTypes, StatementOption } from 'modules/clients/types/client.enum';
import { handleStatementOptionsToggle } from 'modules/clients/utils/statement-form-helper';
import { Control, Controller } from 'react-hook-form';
import SectionWrapper from '../../atoms/section-wrapper/SectionWrapper';
import styles from './statement-form-sections.module.scss';
import { StatementFormValues } from 'modules/clients/types/client.types';

type StatementOptionsProps = {
  control: Control<StatementFormValues, StatementFormValues, StatementFormValues>;
  statementType: string | null;
  disabled: boolean;
};

export const StatementOptions = ({ control, statementType, disabled }: StatementOptionsProps) => {
  return (
    <SectionWrapper disabled={disabled}>
      <Typography
        variant={Typography.VARIANT.H5}
        weight={Typography.WEIGHT.MEDIUM}
        color={Typography.COLOR.DEFAULT}
      >
        Statement options
      </Typography>

      <Typography
        variant={Typography.VARIANT.B3}
        weight={Typography.WEIGHT.NORMAL}
        color={Typography.COLOR.INHERIT}
        className={styles.subHeading}
      >
        {statementType === StatementTypes.internalRateOfReturnInv
          ? 'Select one or more options to include in your statement (required).'
          : 'Select one or more options to include in your statement (optional).'}
      </Typography>

      <Controller
        name='statementOptions'
        control={control}
        render={({ field }) => (
          <div className={styles.statementOptions}>
            <Show when={statementType === StatementTypes.internalRateOfReturnInv}>
              <Checkbox
                onChange={(val) => handleStatementOptionsToggle(val, StatementOption.netIRR, field)}
              >
                {StatementOption.netIRR}
              </Checkbox>
              <Checkbox
                onChange={(val) =>
                  handleStatementOptionsToggle(val, StatementOption.grossIRR, field)
                }
              >
                {StatementOption.grossIRR}
              </Checkbox>
            </Show>

            <Show when={statementType === StatementTypes.transactionSummary}>
              <Checkbox
                onChange={(val) =>
                  handleStatementOptionsToggle(val, StatementOption.inclIRR, field)
                }
              >
                {StatementOption.inclIRR}
              </Checkbox>
            </Show>
          </div>
        )}
      />
    </SectionWrapper>
  );
};
